import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function EuropaMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M15.6 3.5H5.4v18h10.2a3 3 0 003-3v-9h.6V7.1h-.6v-.6a3 3 0 00-3-3zM7.2 19.7V5.3h8.4a1.2 1.2 0 011.2 1.2v12a1.2 1.2 0 01-1.2 1.2H7.2z" /><text transform="matrix(.5705 0 0 .5739 3.272 .451)" stroke="#000" fontSize={24} y={28.34} x={7.633} strokeWidth={0}>{"E"}</text></Svg>;
}
export default EuropaMedium;